import api from '../../services/api';

const RECURSO_CATALOGO = '/exames/catalogo/';
const RECURSO_PARAMETRIZACAO = '/exames/linha-cuidado/parametrizacao/';
const RECURSO_RESULTADOS = '/exames/linha-cuidado/resultados/';
const RECURSO_DOCUMENTOS = '/exames/linha-cuidado/resultados/documentos/';

class ExamesLinhaCuidadoService {
    listarCatalogo(nome = '', apenasAtivos = true) {
        const params = { nome };

        if (apenasAtivos) {
            params.status = true;
        }

        return api.get(RECURSO_CATALOGO, { params });
    }

    cadastrarExame(nome, codigo) {
        return api.post(RECURSO_CATALOGO, { nome, codigo: codigo || '' });
    }

    listarParametrizacao(programaId) {
        return api.get(RECURSO_PARAMETRIZACAO, { params: { programa_id: programaId } });
    }

    incluirParametrizacao(programaId, exameId, periodicidade, obrigatorio = true) {
        return api.post(RECURSO_PARAMETRIZACAO, {
            programa_id: programaId,
            exame_id: exameId,
            periodicidade,
            obrigatorio,
        });
    }

    atualizarParametrizacao(id, dados) {
        return api.put(`${RECURSO_PARAMETRIZACAO}${id}/`, dados);
    }

    removerParametrizacao(id) {
        return api.delete(`${RECURSO_PARAMETRIZACAO}${id}/`);
    }

    listarResultados(atendimentoId) {
        return api.get(RECURSO_RESULTADOS, { params: { atendimento_id: atendimentoId } });
    }

    registrarResultado(dados) {
        return api.post(RECURSO_RESULTADOS, dados);
    }

    atualizarResultado(id, dados) {
        return api.put(`${RECURSO_RESULTADOS}${id}/`, dados);
    }

    removerResultado(id) {
        return api.delete(`${RECURSO_RESULTADOS}${id}/`);
    }

    enviarDocumento(resultadoId, arquivo) {
        const formData = new FormData();
        formData.append('resultado_id', resultadoId);
        formData.append('arquivo', arquivo);

        return api.post(RECURSO_DOCUMENTOS, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }

    excluirDocumento(documentoId) {
        return api.delete(`${RECURSO_DOCUMENTOS}${documentoId}/`);
    }
}

const examesLinhaCuidadoService = new ExamesLinhaCuidadoService();

export default examesLinhaCuidadoService;
